import React from 'react';

import {useWritableContext} from 'insights/WritableContext';

interface AnalyticsBlockErrorMessageProps {
  openBlockEditor: () => void;
}

/**
 * Component used by AnalyticsBlock to define the content of its error message for its use of ErrorUniversalBlockView
 *
 * ErrorUniversalBlockView defines the styling of the error message, so this component only needs to define
 * the html content of the error.
 */
export default function AnalyticsBlockErrorMessage({
  openBlockEditor,
}: AnalyticsBlockErrorMessageProps): JSX.Element {
  const writable = useWritableContext();

  return <>Query is invalid. {writable && <a onClick={openBlockEditor}>Edit</a>}</>;
}
